import { Component, OnInit } from '@angular/core';
import { PortalProductsService } from '@fgb/core';

@Component({
  selector: 'fgb-subscriptions-page',
  templateUrl: './subscriptions-page.component.html',
  styleUrls: ['./subscriptions-page.component.scss']
})
export class SubscriptionsPageComponent implements OnInit {

  constructor(private portalProductsService: PortalProductsService) { }

  ngOnInit() {
    this.portalProductsService.fetchPortalProducts().toPromise();
  }

}
